import IPCIDR from "ip-cidr"

const useCIDR = () => {
	/**
	 * Check if the address's format is legal.
	 * The address must be a valid IP address. Which between 0.0.0.0 ~ 255.255.255.255 with 4 octets.
	 * @param {string} address - The address to validate. e.g. "192.168.0.0"
	 * @returns {boolean} - Returns true if the address is valid, false otherwise.
	 */
	const validateAddress = (address) => IPCIDR.isValidAddress(address)

	/**
	 * Check if the prefix's format is legal.
	 * The prefix must be a number between 0 and 32.
	 * @param {string} prefix - The prefix to validate. e.g. "24"
	 * @returns {boolean} - Returns true if the prefix is valid, false otherwise.
	 */
	const validatePrefix = (prefix) => IPCIDR.isValidCIDR("0.0.0.0/" + prefix)
	/**
	 * Check if the CIDR's format is valid.
	 * The CIDR must be a start cidr address with a valid prefix.
	 * @param {string} address - The address to validate. e.g. "192.168.0.0"
	 * @param {string} prefix - The prefix to validate. e.g. "24"
	 * @returns {boolean} - Returns true if the CIDR is valid, false otherwise.
	 */
	const validateCIDR = (address, prefix) => IPCIDR.isValidCIDR(address + "/" + prefix)

	/**
	 * Check if the address is the start of the CIDR.
	 * that is because in the use case, when we offer a prefix, the range of the address is set, and the backend requires the address must be the start of the cidr.
	 * so we need to check if the address is the start of the cidr.
	 * @param {string} address - The address to validate
	 * @param {string} prefix - The prefix to validate
	 * @returns {boolean} - Returns true if the address is the start of the CIDR, false otherwise.
	 */
	const validateCIDRAddress = (address, prefix) => new IPCIDR(address + "/" + prefix).start() === address

	return {
		validateAddress,
		validatePrefix,
		validateCIDR,
		validateCIDRAddress
	}
}

export default useCIDR
